import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { VERSAO_MOTOR } from '@/lib/fiscal/confronto';
import { useClientesPermitidos } from '@/hooks/usuarios/useUsuarioClientes';
import { montarPainel, type FonteAgenda, type ResumoCliente } from '@/lib/fiscal/painel';

// fiscal_painel_resumo ainda não está nos tipos gerados.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sb: any = supabase;

/**
 * Dados do Painel fiscal (RPC fiscal_painel_resumo + agenda das fontes) já montados em clientes e alertas, só com os
 * clientes que o usuário pode ver. Usado pela tela do Painel e pelo sino do cabeçalho (mesma consulta em cache).
 */
export function usePainelFiscal({ enabled = true }: { enabled?: boolean } = {}) {
  const query = useQuery({
    queryKey: ['fiscal-painel-resumo'],
    staleTime: 60_000,
    enabled,
    queryFn: async () => {
      const [resumo, fontes] = await Promise.all([
        sb.rpc('fiscal_painel_resumo'),
        sb.from('fiscal_fonte').select('codigo, nome, agenda_frequencia, agenda_proxima'),
      ]);
      if (resumo.error) throw resumo.error;
      // A agenda das fontes é um complemento: sem as colunas (migration antiga), o painel segue sem esse alerta.
      return { resumos: (resumo.data ?? []) as ResumoCliente[], fontes: (fontes.error ? [] : fontes.data ?? []) as FonteAgenda[] };
    },
  });

  const permitidos = useClientesPermitidos();
  const { data } = query;
  const painel = useMemo(
    () => (data ? montarPainel(data.resumos.filter((r) => permitidos.pode(r.cnpj)), data.fontes, VERSAO_MOTOR) : null),
    [data, permitidos]
  );

  return { ...query, painel };
}
